import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import SectionTitle from "@/components/base/SectionTitle";
import { hotTopics } from "@/mocks/mangaData";

const filterTags = ["全部", "新番热议", "补番指南", "同人讨论", "避雷现场", "安利种草"];

function TopicDetail({ t }: { t: (typeof hotTopics)[number] }) {
  return (
    <article className="grid grid-cols-1 gap-6 overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-4 md:grid-cols-5 md:p-5">
      <div className="h-56 w-full overflow-hidden rounded-xl md:col-span-2 md:h-auto">
        <img src={t.cover} alt={`${t.title}配图`} className="h-full w-full object-cover" />
      </div>
      <div className="flex flex-col md:col-span-3">
        <span className="w-fit rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
          {t.tag}
        </span>
        <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
          {t.title}
        </h3>
        <p className="mt-3 flex-1 text-sm leading-7 text-foreground-600">{t.excerpt}</p>
        <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-background-200 pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-4">
            <span className="flex items-center gap-1">
              <i className="ri-heart-3-line text-accent-500"></i>
              {t.likes.toLocaleString()} 热度
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i>
              {t.comments.toLocaleString()} 讨论
            </span>
            <span>{t.date}</span>
          </span>
          <button
            type="button"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            参与讨论
          </button>
        </div>
      </div>
    </article>
  );
}

export default function Topic() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? hotTopics : hotTopics.filter((t) => t.tag === active);

  return (
    <>
      <Navbar />
      <main className="mx-auto w-full max-w-7xl px-4 py-8 md:px-6 md:py-12">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "热门话题" }]} />
        <div className="mt-6">
          <SectionTitle
            eyebrow="热门话题"
            title="大家都在追什么、聊什么"
            desc="新番热议、补番指南、同人讨论与避雷现场轮番更新，找到志同道合的人，一起把喜欢的故事聊得更深。"
          />
        </div>

        <div className="mt-7 flex flex-wrap gap-2">
          {filterTags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => setActive(tag)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === tag
                  ? "bg-primary-500 font-medium text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        <div className="mt-8 space-y-5">
          {list.map((t) => (
            <TopicDetail key={t.id} t={t} />
          ))}
        </div>

        <div className="mt-10 rounded-2xl border border-background-200 bg-background-100 p-6 text-center">
          <h3 className="font-heading text-lg font-bold text-foreground-950">想发起一个新话题？</h3>
          <p className="mt-2 text-sm text-foreground-600">
            在评论区留下你的看法，优质观点会被收录进本周热门话题推荐。
          </p>
          <Link
            to="/community"
            className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
          >
            前往读者吐槽区发言 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}